import { generatePath } from 'react-router-dom'
import { useAuthenticatedUser } from '@opallabs/api'
import { ZIndex } from '@opallabs/gem'
import { useWorkspace } from '@opallabs/hooks'
import {
  Button,
  ButtonSize,
  Tooltip,
  Link as LapidaryLink,
} from '@opallabs/lapidary'
import { OpalRoutes } from '@opallabs/routing'
import * as styles from '../../styles'

export const ConfigureTypesMessage = () => {
  const { slug: workspaceSlug } = useWorkspace()
  const { data: user } = useAuthenticatedUser({
    routeWorkspaceSlug: workspaceSlug,
  })

  return (
    <div css={styles.messageContainer} className={styles.classes.messageClass}>
      <span>No types have been created or paired with moments yet.</span>

      {user?.isAdminForCurrentWorkspace ? (
        <LapidaryLink
          css={styles.buttonLink}
          href={generatePath(OpalRoutes.ConfigureCategoryTypes, {
            workspaceSlug,
          })}
          target="_top"
        >
          <Button
            disabled={!user?.isAdminForCurrentWorkspace}
            name="Configure Types"
            buttonText="Configure Types"
            variant="tertiary"
            size={ButtonSize.Small}
          />
        </LapidaryLink>
      ) : (
        <Tooltip
          content="Please contact your workspace adminstrator to configure types."
          zIndex={ZIndex.Shroud.Tooltip}
          side="bottom"
        >
          <Button
            disabled
            name="Configure Types"
            buttonText="Configure Types"
            variant="tertiary"
            size={ButtonSize.Small}
            css={styles.buttonLink}
          />
        </Tooltip>
      )}
    </div>
  )
}
